import { useAnalytics } from "./useAnalytics";
import type { AnalyticsData } from "@shared/types/analytics";

interface Display {
  title: string;
  content: string;
}

function describe(data: AnalyticsData | undefined, isError: boolean, isLoading: boolean): Display {
  if (isLoading) return { title: "Premium Leads", content: "Loading…" };
  if (isError || !data) return { title: "Premium Leads", content: "Unable to load data" };
  if (data.urgentCount > 0) {
    return { title: "Premium Leads: Urgent Opportunities", content: `Urgent Count: ${data.urgentCount}` };
  }
  if (data.freshCount > 0) {
    return { title: "Premium Leads: Fresh Data", content: `Fresh Count: ${data.freshCount}` };
  }
  if (data.dialOpportunities > 0) {
    return {
      title: "Premium Leads: Dial Opportunities",
      content: `Dial Opportunities: ${data.dialOpportunities}`,
    };
  }
  return { title: "Premium Leads", content: "None Available" };
}

export function PremiumLeadsCard() {
  const { data, isError, isLoading } = useAnalytics();
  const display = describe(data, isError, isLoading);

  return (
    <section
      aria-live="polite"
      className="mt-8 p-4 rounded-md bg-black/35 text-white text-center text-xl"
    >
      <h1 className="text-[22px] mb-2 text-wallboard-accent">{display.title}</h1>
      <div>{display.content}</div>
    </section>
  );
}
